'use strict';

import { Auth } from '@aws-amplify/auth';
import awsconfig from './aws-exports';
// AWS SDK v2 (legacy - will be gradually replaced)
// AWS SDK v2 import removed - using AWS SDK v3 instead
// AWS SDK v3 (new - using ES modules)
import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import { DynamoDBDocumentClient } from "@aws-sdk/lib-dynamodb";
import { GetCommand, PutCommand, DeleteCommand } from "@aws-sdk/lib-dynamodb";


import CryptoJS from "crypto-js";

export const getDataServiceFn = ($, app, s3, docClient, userSub, apigClient, fnName) => {
    let f = null;


    switch (fnName) {
        case "sendGetHiddenExamGroups":
            {
                f = sendGetHiddenExamGroups_DynamoDB(app, docClient);
                break;
            }
        case "sendPutHiddenExamGroups":
            {
                f = sendPutHiddenExamGroups_DynamoDB(app, docClient);
                break;
            }
        case "sendDeleteHiddenExamGroups":
            {
                f = sendDeleteHiddenExamGroups_DynamoDB(app, docClient);
                break;
            }
        default:
            {
                alert("SmarterMaths says: \n\nOops!  We've misconfigured something, and the app will not work properly.  \n\nPlease notify us at (support@smartermaths.com.au) and we'll get it working for you ASAP!  \n\nMany thanks, SmarterMaths Support.");
                break;
            }
    }
    return f;

};

// *************************************************************************************************************************
// 
// sendGetPost
// ----------------
// 
// *************************************************************************************************************************


const decryptPostContent = (ciphertext) => {

    const bytes  = CryptoJS.AES.decrypt(ciphertext, String.fromCharCode(51) + '794826783725' + String.fromCharCode(54));
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    //console.log(originalText); // 'my message'

    return originalText;
}



// *************************************************************************************************************************
// 
// sendGetUserDataContents
// ----------------
// 
// *************************************************************************************************************************




// *************************************************************************************************************************
// 
// sendGetStudentHistory
// ----------------
// 
// *************************************************************************************************************************






// *************************************************************************************************************************
// 
// sendSaveStudentHistory
// ----------------
// 
// *************************************************************************************************************************


// *************************************************************************************************************************
// 
// sendPutHiddenExamGroups_DynamoDB
// ------------------
// 
// Parameters Are:
// 
// cognitoIdentityId_hiddenExamGroups_tuple
// 
// *************************************************************************************************************************

const sendPutHiddenExamGroups_DynamoDB = (app, docClientOLD) => {
    return (cognitoIdentityId_hiddenExamGroups_tuple) => {

        //console.log("About to sendPutHiddenExamGroups_DynamoDB, with cognitoIdentityId, hiddenExamGroups", cognitoIdentityId_hiddenExamGroups_tuple);

	// SHOULD BE ABLE TO make [attributePair] I think?

	// aws --output json --region ap-southeast-2 dynamodb put-item --table-name sm-explore-hidden-exams --item {"id": {"S": "ap-southeast-2:bd546121-ae7c-48c5-8fe5-ba93bceb47ab"}, "hids": {"M": {"9": {"SS": ["89","19"]}, "7": {"SS": ["55","123"]}, "5": {"SS": ["23","13"]} }}}
	// var params = {
	//     TableName :"sm-explore-hidden-exams",
	//     Item: {"id": "ap-southeast-2:bd546121-ae7c-48c5-8fe5-ba93bceb47ab",
	// 	   "hids": {"9": ["89","19"], "7": ["55","123"], "5": ["23","987"]} 
	// 	  }
	// };

	const sendPutHiddenExamGroupsFn = (docClient) => {
	    var params = {
		TableName :"sm-explore-hidden-exams",
		//ReturnValues: "ALL_NEW", doesn't work as at 2019-02-13 - see https://github.com/aws/aws-sdk-js/issues/803
		Item: {"id": cognitoIdentityId_hiddenExamGroups_tuple[0], //"ap-southeast-2:bd546121-ae7c-48c5-8fe5-ba93bceb47ab",
		       "hids": cognitoIdentityId_hiddenExamGroups_tuple[1] //{9: [89,19], 7: [55,123], 5: [23,987]} 
		      }
	    };
	    	
	    // AWS SDK v3 - use command objects for proper v3 syntax
	    docClient.send(new PutCommand(params))
	    .then(data => {
		//console.log(JSON.stringify(data));
                    //Note: data will be {} if no etags or versioning enabled on bucket, etc..  Body is not in response => So send { isSaved: true }
		    //If success, then the input values were successfully updated, so return them (note: returnValues ALL_NEW does not work with put ... see https://github.com/aws/aws-sdk-js/issues/803)
                    app.ports.onPutHiddenExamGroupsResponse.send({"hids": cognitoIdentityId_hiddenExamGroups_tuple[1]});
	    })
	    .catch(err => {
		    console.log("In sendPutHiddenExamGroups_DynamoDB", JSON.stringify(err));
                    //let msg = err.message.length === 0 ? "Unable to update your exam hide/show selection." : err.message
                    //app.ports.onPutHiddenExamGroupsResponse.send({"hids":msg});
		    let userMessage = "Unable to update your exam hide/show selection."
                    let msg = err.message.length === 0 ? userMessage : err.message
		    //NOTE NOTE NOTE ***** NEEDS TO BE DONE: Error handling as at 2019-02-13 for now will REUSE the deleteHiddenExamGroupsResponse to show error to end user
                    app.ports.onDeleteHiddenExamGroupsResponse.send({data: { isSuccess: false, userMessage: userMessage, developerMessage: msg }});
	    });
	}
	
	Auth.currentCredentials().then( credsSuccess(sendPutHiddenExamGroupsFn), credsFailure("sendPutHiddenExamGroups_DynamoDB"));
	
    };
};

// const sendPutHiddenExamGroups_local = ($, app, userSub) => {
//     return (fromAdminEmail) => {
//         app.ports.onPutHiddenExamGroupsResponse.send("Status: NOT IMPLEMENTED FOR LOCAL USAGE");
//     };
// };



// *************************************************************************************************************************
// 
// sendDeleteHiddenExamGroups_DynamoDB
// ------------------
// 
// Parameters Are:
// 
// Parameter group
// cognitoIdentityId
// 
// *************************************************************************************************************************

const sendDeleteHiddenExamGroups_DynamoDB = (app, docClientOLD) => {
    return (uNameInPool) => {

        //console.log("About to sendDeleteHiddenExamGroups_DynamoDB, with cognitoIdentityId", cognitoIdentityId);

	// SHOULD BE ABLE TO make [attributePair] I think?

	const sendDeleteHiddenExamGroupsFn = (docClient) => {
	    var params = {
		TableName :"sm-explore-hidden-exams",
		Key: {"id": uNameInPool}
	    };
	    // AWS SDK v3 - use command objects for proper v3 syntax
	    docClient.send(new DeleteCommand(params))
	    .then(data => {
		    //console.log(JSON.stringify(data));
                    //Note: data will be {} if no etags or versioning enabled on bucket, etc..  Body is not in response => So send { isSaved: true }
                    app.ports.onDeleteHiddenExamGroupsResponse.send({data: { isSuccess: true }});
	    })
	    .catch(err => {
		    console.log("In sendDeleteHiddenExamGroups_DynamoDB", JSON.stringify(err));
		    let userMessage = "Unable to update your exam hide/show selection. (Attempting to delete all selections)"
                    let msg = err.message.length === 0 ? userMessage : err.message
                    app.ports.onDeleteHiddenExamGroupsResponse.send({data: { isSuccess: false, userMessage: userMessage, developerMessage: msg }});
	    });
	}
	
	Auth.currentCredentials().then( credsSuccess(sendDeleteHiddenExamGroupsFn), credsFailure("sendDeleteHiddenExamGroups_DynamoDB"));

	

    };
};



// *************************************************************************************************************************
// 
// sendGetHiddenExamGroups_DynamoDB
// ------------------
// 
// Parameters Are:
// 
// cognitoIdentityId
// 
// *************************************************************************************************************************


const credsSuccess = hiddenExamGroupsFn => creds => {	    
    //console.log("***** credentials are", creds);
    
    // Get region from aws-exports configuration instead of hardcoding
    let region = awsconfig.aws_project_region || 'ap-southeast-2'; // Fallback to default if not found
    
    // Try to get region from credentials object (v3.x structure) as override
    if (creds && creds.region) {
        region = creds.region;
    } else if (creds && creds._clientConfig && creds._clientConfig.region) {
        // Fallback for v2.x structure
        region = creds._clientConfig.region;
    }
    
    // AWS SDK v3 approach (primary method)
    const dynamoClient = new DynamoDBClient({ 
        region: region,
        credentials: creds 
    });
    const docClient3 = DynamoDBDocumentClient.from(dynamoClient);
    
    // Use v3 directly - no fallback needed
    hiddenExamGroupsFn(docClient3);
}

const credsFailure = fnName => err => console.log("Failed to successfully execute Auth.currentCredentials() as precusor to " + fnName + JSON.stringify(err))


const sendGetHiddenExamGroups_DynamoDB = (app, docClientOLD) => {
    return (uNameInPool) => {

	//NOTE: input parameter cognitoIdentityId no longer used as at 2020-03-16 - rather it is now retrieved from the credentials
        //console.log("About to sendGetHiddenExamGroups_DynamoDB, with cognitoIdentityId", cognitoIdentityId);
	// SHOULD BE ABLE TO make [attributePair] I think?

	const sendGetHiddenExamGroupsFn = (docClient) => {
	    var params = {
		TableName :"sm-explore-hidden-exams",
		Key: {"id": uNameInPool}
	    };
	    
	    // AWS SDK v3 - use command objects for proper v3 syntax
	    docClient.send(new GetCommand(params))
	    .then(data => {
		    //console.log("in sendGetHiddenExamGroups_DynamoDB");
		    //console.log(JSON.stringify(data), data); 
                    //app.ports.onGetAttributesResponse.send(JSON.parse(data.Item.toString()));
                    app.ports.onGetHiddenExamGroupsResponse.send(data.Item);
	    })
	    .catch(err => {
		    //NOTE NOTE **** CURRENTLY as at 2019-02-13 this will fail with a message to the console only (effectively silent to end user)
		    console.log("In sendGetHiddenExamGroups_DynamoDB", JSON.stringify(err));
                    //let msg = err.message.length === 0 ? "Unable to retrieve suppressed exam ids." : err.message
                    //app.ports.onGetHiddenExamGroupsResponse.send(msg);
	    });
	}
	
	Auth.currentCredentials().then( credsSuccess(sendGetHiddenExamGroupsFn), credsFailure("sendGetHiddenExamGroups_DynamoDB"));

    };
};



